import React, { useEffect, useState } from "react";
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
/* ICONS */
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import CachedIcon from '@mui/icons-material/Cached';

import { ListItemIcon, ListItemText, Menu, MenuItem, Snackbar, Alert, Divider } from '@mui/material';

import { AddCategory } from 'components/dialog/category/AddCategory';
import { EditCategory } from 'components/dialog/category/EditCategory';
import { DeactivateCategory } from 'components/dialog/category/DeactivateCategory';
import { InfoCategory } from 'components/dialog/category/InfoCategory';
import { getCategories } from 'utils/Category';

const ContextMenu = ({ contextMenu, setContextMenu, selectedRow, reloading, rows }) => {

    const { t } = useTranslation();
    const [openAdd, setOpenAdd] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [openDeactivate, setOpenDeactivate] = useState(false)
    const [openInfo, setOpenInfo] = useState(false)
    const [openAlert, setOpenAlert] = useState(false)
    const [alert, setAlert] = useState({ msg: '', severity: '' })
    const select = rows.find(row => row.id === selectedRow[0])

    const options = [
        {
            name: t('custom_reports.category.table.context_menu.add'),
            icon: <AddIcon />,
            click: () => {setOpenAdd(true); setContextMenu(null)},
            color: '',
            selected: false,
            onlyOne: false,
            disabled: JSON.parse(localStorage.getItem('permissions')).find(permision => permision === 'custom_reports.CreateCategory') ? false : true
        },
        {
            name: t('custom_reports.category.table.context_menu.edit'),
            icon: <EditIcon />,
            click: () => {setOpenEdit(true); setContextMenu(null)},
            color: '',
            selected: true,
            onlyOne: true,
            disabled: JSON.parse(localStorage.getItem('permissions')).find(permision => permision === 'custom_reports.UpdateCategory') ? false : true
        },
        {
            name: select?.status === 'Enabled' ? t('custom_reports.category.table.context_menu.deactivate') : t('custom_reports.category.table.context_menu.activate'),
            icon: <DeleteIcon />,
            click: () => {
                setOpenDeactivate(true);
                setContextMenu(null)
            },
            color: '',
            selected: true,
            onlyOne: true,
            disabled: JSON.parse(localStorage.getItem('permissions')).find(permision => permision === 'custom_reports.DeactivateCategory') ? false : true
        },
        {
            name: t('custom_reports.category.table.context_menu.info'),
            icon: <InfoIcon />,
            click: () => {setOpenInfo(true); setContextMenu(null)},
            color: '',
            selected: true,
            onlyOne: true,
            disabled: JSON.parse(localStorage.getItem('permissions')).find(permision => permision === 'custom_reports.GetCategoryByID') ? false : true
        },
        {
            name: t('custom_reports.category.table.context_menu.reload'),
            icon: <CachedIcon />,
            click: () => {reloading(); setContextMenu(null)},
            color: '',
            selected: false,
            onlyOne: false
        }
    ]

    return (
        <>
            <Menu
                open={contextMenu ? true : false}
                onClose={() => setContextMenu(null)}
                anchorReference="anchorPosition"
                anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
                sx={{ boxShadow: 'none' }}
            >
                {options.map((option, index) =>
                    <div key={index} hidden={option.onlyOne && selectedRow.length !== 1}>
                        {option.divider ? <Divider /> : null}

                        <MenuItem
                            onClick={option.click}
                            disabled={option.disabled}
                        >
                            <ListItemIcon>
                                {option.icon}
                            </ListItemIcon>
                            <ListItemText primary={option.name} slotProps={{ primary: {color: option.color} }} />
                        </MenuItem>
                    </div>
                )}
            </Menu>
            <AddCategory open={openAdd} setOpen={setOpenAdd} rows={rows} setAlert={setAlert} setOpenAlert={setOpenAlert} reloading={reloading}/>
            <EditCategory open={openEdit} setOpen={setOpenEdit} rows={rows} selectedRow={selectedRow} setAlert={setAlert} setOpenAlert={setOpenAlert} reloading={reloading}/>
            <DeactivateCategory open={openDeactivate} setOpen={setOpenDeactivate} rows={rows} selectedRow={selectedRow} setAlert={setAlert} setOpenAlert={setOpenAlert} reloading={reloading}/>
            <InfoCategory open={openInfo} setOpen={setOpenInfo} rows={rows} selectedRow={selectedRow} setAlert={setAlert}/>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={openAlert}
            >
                <Alert
                    severity= {alert.severity}
                    onClose={() => setOpenAlert(false)}
                    sx={{ width: '100%' }}
                >
                    {alert.msg}
                </Alert>
            </Snackbar>

        </>
    );
}

const CategoryTable = () => {
    const { t } = useTranslation();
    const [rows, setRows] = useState([])
    const [selectedRow, setSelectedRow] = useState([])
    const [contextMenu, setContextMenu] = useState(null)
    const [loading, setLoading] = useState(false)


    const columns = [
        {
            field: 'name',
            headerName: t('custom_reports.category.table.columns.name'),
            flex: 1,
            filterable: false,
        },
        {
            field: 'created_at',
            headerName: t('custom_reports.category.table.columns.create_at'),
            flex: 1,
            filterable: false,
        },
        {
            field: 'created_by',
            headerName: t('custom_reports.category.table.columns.create_by'),
            flex: 1,
            filterable: false,
        },
        {
            field: 'updated_at',
            headerName: t('custom_reports.category.table.columns.update_at'),
            flex: 1,
            filterable: false,
        },
        {
            field: 'updated_by',
            headerName: t('custom_reports.category.table.columns.update_by'),
            flex: 1,
            filterable: false,
        },
    ]



    const reloading = async () => {
        setLoading(true);
        try{
            const response = await getCategories();
            const records = response?.result?.map((row) => {
                return {
                    id: row.id,
                    name: row.name,
                    created_at: row.created_at,
                    created_by: row.created_by,
                    updated_at: row.updated_at,
                    updated_by: row.updated_by,
                }
            })
            setRows(records);
            setLoading(false);

        }catch(error){
            console.error(error);
            setLoading(false);
            setRows([]);
        }
    }

    useEffect(() => {
        reloading()
    }, [])

    return (
        <>
            <div
                sx={{ width: '100%', height: '100%' }}
                onContextMenu={(event) => {
                    event.preventDefault();
                    setContextMenu(contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6} : null)
                }}
            >
                <DataGridPro
                    sx={{ height: 'calc(100vh - 140px)' }}
                    columns={columns}
                    rows={rows}
                    showCellVerticalBorder
                    showColumnVerticalBorder
                    disableColumnMenu
                    headerFilters
                    loading={loading}
                    checkboxSelection
                    pagination
                    localeText={
                        {
                            headerFilterOperatorContains: t('general.table.headerFilters.headerFilterOperatorContains'),
                            headerFilterOperatorEquals: t('general.table.headerFilters.headerFilterOperatorEquals'),
                            headerFilterOperatorStartsWith: t('general.table.headerFilters.headerFilterOperatorStartsWith'),
                            headerFilterOperatorEndsWith: t('general.table.headerFilters.headerFilterOperatorEndsWith'),
                            headerFilterOperatorIsEmpty: t('general.table.headerFilters.headerFilterOperatorIsEmpty'),
                            headerFilterOperatorIsNotEmpty: t('general.table.headerFilters.headerFilterOperatorIsNotEmpty'),
                            footerRowSelected: (count) =>
                                count > 1
                                ? t('general.table.footerFilters.footerRowSelected.>1', {count: count.toLocaleString()})
                                : t('general.table.footerFilters.footerRowSelected.=1', {count: count.toLocaleString()}),

                            footerTotalRows: t('general.table.footerFilters.footerTotalRows'),
                            MuiTablePagination: {
                                labelDisplayedRows: ({ from, to, count }) =>
                                    t('general.table.footerFilters.labelDisplayedRows', {from: from.toLocaleString(), to: to.toLocaleString(), count: count.toLocaleString()}),
                                labelRowsPerPage: t('general.table.footerFilters.labelRowsPerPage'),},
                        }
                    }

                    onRowSelectionModelChange={(newRowSelectionModel) => {
                        setSelectedRow(newRowSelectionModel);
                    }}
                    rowSelectionModel={selectedRow}

                />

                <ContextMenu
                    contextMenu={contextMenu}
                    setContextMenu={setContextMenu}
                    selectedRow={selectedRow}
                    reloading={reloading}
                    rows={rows}
                />
            </div>
        </>
    );
}

export { CategoryTable }